const level = [
  [  0,   0,  99,  99,  99,   0,   0,   0,   0,   0],
  [  0,  99,  99,  77,  99,   0,   0,   0,   0,   0],
  [  0,  99,   0,  10,  99,  99,  99,  99,   0,   0],
  [ 99,  99,   0,   0,   0,   9,  52,  99,   0,   0],
  [ 99,  38,   0,   7,   8,  64,  99,  99,   0,   0],
  [ 99,  99,  99,  99,   0,  99,  99,   0,   0,   0],
  [  0,   0,   0,  99,  51,  99,   0,   0,   0,   0],
  [  0,   0,   0,  99,  99,  99,   0,   0,   0,   0],

]

export default level